export const environment = {
  agencyCode: "armsdata-test",
  domain: "https://armsdata-test.azurewebsites.net/",
  apiUrl: "https://app-armstracker-api-test.azurewebsites.net/",
  production: true,
};
